module.exports = __webpack_public_path__ + "files/5e6844e3d9e3f562adb0e7fa224dedc2.png";